module.exports = __webpack_public_path__ + "static/media/texture (22).a93cab6d.jpg";